import CloseIcon from "@material-ui/icons/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Radio,
  RadioGroup
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import * as React from "react";
import ErrorHelperText from "../../../Components/online-recruitment/component/errorHelperText";

const ConfirmationModel = (props) => {
  const { open, setOpen, modelTitle, healthName, handleSubmit } = props;

  const handleClose = () => setOpen(false);

  const [jobStatus, setJobStatus] = React.useState(null);
  const [value, setValue] = React.useState({})

  const handleApproveJob = () => {
    if (jobStatus == 'Yes') {
      handleSubmit()
    }
  }

  return (
    <>
      {open ? (
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" >
            <h6 className=" d-flex justify-content-between align-items-center">{modelTitle} {healthName}  <IconButton
              aria-label="close"
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
            </h6>
          </DialogTitle>

          <DialogContent dividers>

            <Typography gutterBottom>

              {/* {/ {getRemaingDay(currentView?.CreatedDate)} /} */}
            </Typography>
            <Typography gutterBottom>
              <FormControl id={"status"}>
                <RadioGroup
                  aria-label="status"
                  value={jobStatus}
                  style={{ display: "block" }}
                  onClick={(e) => {
                    setJobStatus(e.target.value);
                    setValue({ ...value, "status": e.target.value })
                  }}
                >
                  <FormControlLabel
                    className="px-24 py-8"
                    value={"Yes"}
                    control={<Radio />}
                    label={"Yes"}
                  />
                  <FormControlLabel
                    className="px-24 py-8"
                    value={"No"}
                    control={<Radio />}
                    label={"No"}
                  />
                </RadioGroup>
              </FormControl>
              {!jobStatus && <ErrorHelperText errorMessage={'Confirmation Required *'} className='text-danger' />}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              variant="contained"
              onClick={() => {
                if (!jobStatus) {
                  return false
                }
                handleApproveJob();
                setOpen(false)
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </>
  );
};

export default ConfirmationModel;